module.exports = __webpack_public_path__ + "static/img/preview-05.b1db1d21.webp";